import {WPCheckItem} from "./WPCheckItem";
import {WPEvaluationStep} from "./WPEvaluationStep";

export interface WPDangerEvaluation {
  // DB Value
  uid: number;
  // guid: string;
  evaluationMasterUID: number;
  departmentUID: number; // Deprecated
  evaluator: string; // 평가자
  contents: string; // 내용 // Deprecated
  revisionDate: Date | string; // 개정일
  revisionNo: number; // 개정 번호
  reason: string; // 개정 사유
  extra: string; // 비고사항
  serialNo: number; // 일련번호 // Deprecated
  material: string; // 취급 물질 // Deprecated
  isDeleted: boolean;
  isCompleted: boolean; // 검증완료
  entryDate: Date | string;
  modifyDate: Date | string;

  // Not DB
  isOuter: boolean; // 외부 여부 => 외부인 경우 부서명과 평가자는 'N/A' 로 표시한다
  serialMessage: string; // 일련번호 표시
  evaluationSteps: WPEvaluationStep[]; // 작업 단계 목록
  // categories: WPCheckItem[][]; // 작업 항목 - 2차원 jagged 배열 // EX. categories.map((checkItems, categoryIndex) => checkItems.map(item => { ...... }));

  generalCheckItems: WPCheckItem[]; // 일반작업 항목
  fireCheckItems: WPCheckItem[]; // 화기작업 항목
  closedCheckItems: WPCheckItem[]; // 밀폐작업 항목
  stopElectricityCheckItems: WPCheckItem[]; // 정전작업 항목
  excavationCheckItems: WPCheckItem[]; // 굴착작업 항목
  radiationCheckItems: WPCheckItem[]; // 방사선작업 항목
  heightCheckItems: WPCheckItem[]; // 고소작업 항목
  heavyCheckItems: WPCheckItem[]; // 중장비작업 항목
}

export const initializeDangerEvaluation = (id?: number): WPDangerEvaluation => {
  return {
    // DB Value
    uid: 0,
    // guid: generateUUID(),
    evaluationMasterUID: id!,
    departmentUID: 0,
    evaluator: "", // 평가자
    contents: "", // 내용
    revisionDate: new Date(), // 개정일
    revisionNo: 0, // 개정 번호
    reason: "", // 개정 사유
    extra: "", // 비고사항
    serialNo: 0, // 일련번호
    material: "", // 취급 물질
    isDeleted: false,
    isCompleted: false, // 검증완료
    entryDate: new Date(),
    modifyDate: new Date(),

    // Not DB
    isOuter: false,
    serialMessage: "",
    evaluationSteps: [] as WPEvaluationStep[], // 작업 단계 목록

    generalCheckItems: [] as WPCheckItem[], // 일반작업 항목
    fireCheckItems: [] as WPCheckItem[], // 화기작업 항목
    closedCheckItems: [] as WPCheckItem[], // 밀폐작업 항목
    stopElectricityCheckItems: [] as WPCheckItem[], // 정전작업 항목
    excavationCheckItems: [] as WPCheckItem[], // 굴착작업 항목
    radiationCheckItems: [] as WPCheckItem[], // 방사선작업 항목
    heightCheckItems: [] as WPCheckItem[], // 고소작업 항목
    heavyCheckItems: [] as WPCheckItem[], // 중장비작업 항목
  };
};
export interface EvaluationListParams {
  page: number;
  rows: number;
  token: string;
  contents: string;
  departmentUID: number; // -1 은 전체
  range: number; // -1 전체, 0 - 내부, 1 - 외부
  startDate: Date | string | null;
  endDate: Date | string | null;
}

export const initializeEvaluationListParams = (): EvaluationListParams => {
  return {
    page: 1,
    rows: 30,
    token: "",
    contents: "",
    departmentUID: -1, // -1 은 전체
    range: -1, // -1 전체, 0 - 내부, 1 - 외부
    startDate: null,
    endDate: null,
  };
};

export const CategoryNames = [
  "일반작업",
  "화기작업",
  "밀페작업",
  "정전작업",
  "굴착작업",
  "방사선",
  "고소작업",
  "중장비",
];

function generateUUID() {
  // Public Domain/MIT
  var d = new Date().getTime(); //Timestamp
  var d2 = (typeof performance !== "undefined" && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}
